import React from 'react';

export const ErrorIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <g fill="none" fill-rule="evenodd" stroke="#F64D43">
      <path d="M12 20.5a8.5 8.5 0 1 1 0-17 8.5 8.5 0 0 1 0 17zm0 0a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17z" />
      <path fill-rule="nonzero" d="M12 7.02v6.983M12 16.01v.977" />
    </g>
  </svg>
);
